import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { WelfarestatusupdateResponseModel, WelfareupdatestatusResponseModel } from '../welfare/dto/welfare-response-model';
import { WelfareidstatusDTO } from '../welfare/dto/welfare.dto';
import { WelfareStatusEntity } from './welfarestatus.entity';

@Injectable()
export class WelfarestatusService {

    constructor(
      
        @InjectRepository(WelfareStatusEntity)
        private welfarestatusRepository: Repository<WelfareStatusEntity>
    ) {}

    
     async updateWelfarestatus(queryParams, WelfareidstatusDTO: WelfareidstatusDTO, request:Request): Promise<WelfareupdatestatusResponseModel> {
      const response = new WelfareupdatestatusResponseModel();
      console.log(WelfareidstatusDTO,"data")
      try {
          if(queryParams.apiVersion == 1) {
              const updatePostType = await this.welfarestatusRepository.update(WelfareidstatusDTO.Id, WelfareidstatusDTO);
              console.log(updatePostType)
              const updatedData = await this.welfarestatusRepository.find({
                relations:['welfare'],
                where:{welfareStatusId:WelfareidstatusDTO.welfareStatusId}
            });
              if(updatePostType) {
                  response.status = true;
                  response.data = updatedData;
                  response.statusCode = 50000;
                  response.internalMessage = 'welfare status updated successfully';
                  response.intlCode = 11108;
              } else {
                  throw new ErrorResponse(99998, 'welfare status Update Failed')
              }
          } else {
            const updatePostType = await this.welfarestatusRepository.update(WelfareidstatusDTO.welfareStatusId, WelfareidstatusDTO);
            
             
              const updatedData = await this.welfarestatusRepository.find({
                relations:['welfare'],
                where:{welfareStatusId:WelfareidstatusDTO.welfareStatusId}
            });
              if(updatePostType) {
                  response.status = true;
                  response.data = updatedData;
                  response.statusCode = 50000;
                  response.internalMessage = 'welfare status updated successfully';
                  response.intlCode = 11108;
              } else {
                  throw new ErrorResponse(99998, 'welfare status Update Failed')
              }
          }
          return response;
      } catch (error) {
          throw error;
      }
    
      
    }

    async getAllWelfarestatus(queryParams, request:Request): Promise<WelfareupdatestatusResponseModel>{
      const response = new WelfareupdatestatusResponseModel();
      try{
        if (queryParams.apiVersion == 1) {
          const welfare = await this.welfarestatusRepository.find({
            relations:['welfare'],
            where: {status: true},
                      order: { createdAt: 'DESC' }
          });
          if(welfare){
            response.status = true;
            response.data = welfare;
            response.statusCode = 50000;
            response.internalMessage = 'Data retrived successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998,'Data not found');
          }
        } else {
          const welfare = await this.welfarestatusRepository.find({
            relations:['welfare'],
            where: {status: true},
            order: { createdAt: 'DESC' }
          });
          if(welfare){
            response.status = true;
            response.data = welfare;
            response.statusCode = 50000;
            response.internalMessage = 'Data retrieved successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse (99998, 'Data not found');
          }
        }
        return response;
      }catch( err) {
        throw err;
        }
      }
      async getWelfareByWelfarestatusId(queryParams, welfareStatusId: number, request:Request): Promise<WelfarestatusupdateResponseModel> {
        const response = new WelfarestatusupdateResponseModel();
        try {
          if (queryParams.apiVersion == 1) {
            const welfareRespone = await this.welfarestatusRepository.findOne({
                relations:['welfare'],
                        where:{welfareStatusId:welfareStatusId}
            });
            if (welfareRespone) {
              response.status = true;
              response.statusCode = 50000;
              response.internalMessage = 'welfare record found';
              response.intlCode = 11107;
              response.data = welfareRespone;
            } else {
              throw new ErrorResponse(99998, 'Welfare record not found');
            }
          } else {
              const welfareRespone = await this.welfarestatusRepository.findOne({
                relations:['welfare'],
                            where:{welfareStatusId:welfareStatusId}
                });
                if (welfareRespone) {
                  response.status = true;
                  response.statusCode = 50000;
                  response.internalMessage = 'welfare record found';
                  response.intlCode = 11107;
                  response.data = welfareRespone;
                } else {
                  throw new ErrorResponse(99998, 'Welfare record not found');
                }
          }
          return response;
        } catch (error) {
          throw error;
        }
      }
}
